import React from 'react'
import { translate, checkTranslation, pathMaker } from '../../utils/useful'
import { userSections } from '../../variables/userPages'
import { siteTheme } from '../../variables/config'
import { withRouter } from 'react-router-dom'
import TLink from '../../components/TLink'

const colors = siteTheme.primaryColors

class SignUpUserTypeStep extends React.Component {
    state = {
        selectedType: null
    }

    selectUserType = (type) => {
        this.setState({ selectedType: type }, () => {
            this.props.setData({ userType: type }, () => {
                if (this.props.stageManager) {
                    this.props.stageManager.nextStage()
                }
            })
        })
    }

    goBack = () => {
        this.props.history.push(pathMaker('/login'))
    }

    render() {
        return (
            <div className="flexcc flex-column">
                <img className="mb-3" src={siteTheme.logo} width={'100px'} />
                <h2 className="mt-0 mb-4" style={{ fontSize: 24, color: colors.main1 }}>{translate('Select User Type')}</h2>
                <p className="mb-4" style={{ fontSize: 14, color: '#789', maxWidth: 400, textAlign: 'center' }}>{translate('Please select your user type to continue')}</p>

                <div className="w-100" style={{ maxWidth: 500 }}>
                    <div className="row m-0">
                        {Object.values(userSections).map((section, index) => {
                            return (
                                <div key={index} className="col-12 col-md-6 mb-3">
                                    <div
                                        onClick={() => this.selectUserType(section.key)}
                                        className="w-100 p-4 cursor-pointer"
                                        style={{
                                            background: this.state.selectedType === section.key 
                                                ? `linear-gradient(135deg, ${colors.main1} 0%, ${colors.main1} 75%, ${colors.main2} 100%)` 
                                                : `linear-gradient(135deg, ${colors.main3}15, #ffffff)`,
                                            border: `2px solid ${this.state.selectedType === section.key ? colors.main1 : colors.main3 + '50'}`,
                                            borderRadius: 16,
                                            transition: 'all 0.3s ease',
                                            boxShadow: this.state.selectedType === section.key 
                                                ? `0 8px 25px ${colors.main1}50` 
                                                : `0 2px 8px ${colors.main3}30`
                                        }}
                                        onMouseEnter={(e) => {
                                            if (this.state.selectedType !== section.key) {
                                                e.currentTarget.style.transform = 'translateY(-2px)'
                                                e.currentTarget.style.boxShadow = `0 4px 15px ${colors.main3}40`
                                                e.currentTarget.style.borderColor = colors.main3
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (this.state.selectedType !== section.key) {
                                                e.currentTarget.style.transform = 'translateY(0)'
                                                e.currentTarget.style.boxShadow = `0 2px 8px ${colors.main3}30`
                                                e.currentTarget.style.borderColor = colors.main3 + '50'
                                            }
                                        }}
                                    >
                                        <div className="flexcc flex-column">
                                            <img src={section.img || '/images/icons/user.png'} width="60px" className="mb-3" />
                                            <h3 style={{ 
                                                fontSize: 18, 
                                                fontWeight: 600, 
                                                color: this.state.selectedType === section.key ? '#fff' : colors.main1,
                                                margin: 0 
                                            }}>
                                                {checkTranslation(section.name)}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    
                    <div className="text-center mt-4">
                        <button
                            onClick={this.goBack}
                            style={{
                                background: `linear-gradient(135deg, ${colors.main3}50, ${colors.main3}60)`,
                                border: `2px solid ${colors.main3}80`,
                                borderRadius: 50,
                                padding: '12px 35px',
                                fontSize: 15,
                                fontWeight: 600,
                                color: colors.main1,
                                cursor: 'pointer',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: `0 2px 8px ${colors.main3}30`,
                                minWidth: 140,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 8
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${colors.main3}65, ${colors.main3}75)`
                                e.currentTarget.style.borderColor = colors.main3
                                e.currentTarget.style.transform = 'translateY(-2px)'
                                e.currentTarget.style.boxShadow = `0 4px 12px ${colors.main3}40`
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${colors.main3}50, ${colors.main3}60)`
                                e.currentTarget.style.borderColor = colors.main3 + '80'
                                e.currentTarget.style.transform = 'translateY(0)'
                                e.currentTarget.style.boxShadow = `0 2px 8px ${colors.main3}30`
                            }}
                        >
                            <span>←</span> {translate('Back to Login')}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(SignUpUserTypeStep)

